var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.33609C10.2652 2.07087 10.6249 1.92188 11 1.92188C11.1857 1.92188 11.3696 1.95845 11.5412 2.02953C11.7128 2.1006 11.8687 2.20477 12 2.33609C12.1313 2.46741 12.2355 2.62331 12.3066 2.79489C12.3776 2.96647 12.4142 3.15037 12.4142 3.33609C12.4142 3.52181 12.3776 3.7057 12.3066 3.87728C12.2355 4.04886 12.1313 4.20477 12 4.33609L3.66667 12.6694L1 13.3361L1.66667 10.6694L10 2.33609Z",
    stroke: "#6d4096",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorEditIcon);
export default __webpack_public_path__ + "static/media/colorEditIcon.1a2df0b8aaffd5969526a458c14924b9.svg";
export { ForwardRef as ReactComponent };